import { getCotizaDets, createCotizaDet, updateCotizaDet, deleteCotizaDet } from '../models/cotizaDetModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

export async function fetchCotizaDets(cotizaCabId, page, perPage) {
  try {
    const response = await getCotizaDets(cotizaCabId, page, perPage);
    return {
      cotiza_det: response.items,
      totalItems: response.totalItems,
      page: response.page,
    };
  } catch (error) {
    console.error("Error fetching cotiza_det:", error);
    Swal.fire('Error', 'No se pudieron cargar los detalles de la cotización', 'error');
    return null;
  }
}

export async function saveCotizaDet(cotizaDet, currentCotizaDetId) {
  try {
    if (currentCotizaDetId) {
      await updateCotizaDet(currentCotizaDetId, cotizaDet);
      toasts.add({
        title: 'Éxito',
        description: 'Detalle de cotización guardado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    } else {
      await createCotizaDet(cotizaDet);
      toasts.add({
        title: 'Éxito',
        description: 'Detalle de cotización creado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    }
  } catch (error) {
    console.error("Error saving cotiza_det:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el detalle de cotización',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  }
}

export async function removeCotizaDet(id) {
  try {
    await deleteCotizaDet(id);
    toasts.add({
      title: 'Éxito',
      description: 'Detalle de cotización eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  } catch (error) {
    console.error("Error deleting cotiza_det:", error);
    Swal.fire('Error', 'No se pudo eliminar el detalle de cotización', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'cotiza_det'
export function subscribeToCotizaDets(cotizaCabId, searchQuery, handleSearch) {
  pb.collection('cotiza_det').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(); // Actualiza la lista manteniendo la página actual
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromCotizaDets() {
  pb.collection('cotiza_det').unsubscribe('*');
}

export async function searchCotizaDets(cotizaCabId, query, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('cotiza_det').getList(page, perPage, {
      filter: `cotiza_cab = "${cotizaCabId}" && (producto.nombre ~ "${query}" || producto.descripcion ~ "${query}")`,
      expand: 'producto'
    });
    return {
      cotiza_det: response.items,
      totalItems: response.totalItems,
      page: response.page,
    };
  } catch (error) {
    console.error("Error searching cotiza_det:", error);
    Swal.fire('Error', 'No se pudieron buscar los detalles de la cotización', 'error');
    return null;
  }
}

// Calcular total de la cotización
export async function calculateCotizaTotal(cotizaCabId) {
  try {
    const response = await pb.collection('cotiza_det').getList(1, 1000, {
      filter: `cotiza_cab = "${cotizaCabId}"`,
      fields: 'total'
    });
    
    const total = response.items.reduce((sum, item) => sum + (item.total || 0), 0);
    return total;
  } catch (error) {
    console.error("Error calculating cotiza total:", error);
    return 0;
  }
}

// Actualizar total en cotiza_cab
export async function updateCotizaCabTotal(cotizaCabId) {
  try {
    const total = await calculateCotizaTotal(cotizaCabId);
    await pb.collection('cotiza_cab').update(cotizaCabId, { total });
    return total;
  } catch (error) {
    console.error("Error updating cotiza_cab total:", error);
    return 0;
  }
}
